import { render, staticRenderFns } from "./DestinationMustSeeEntityPageLink.vue?vue&type=template&id=8c8f9464&"
import script from "./DestinationMustSeeEntityPageLink.vue?vue&type=script&lang=js&"
export * from "./DestinationMustSeeEntityPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports